<template>
  <div>
    <div class="total">Total: {{driversTotal}}</div>
    <div v-if="drivers.length > 0 || totalPages > 0">
      <table>
        <thead>
          <tr class="table-header">
            <th></th>
            <th v-show="onDuty"></th>
            <th v-bind:class="'sortable' + (isSorting ? ' disabled' : '')" @click="sort('ID')">
              <span>{{ $t('dispatch.driverTable.id') }}</span>
              <span v-show="driverSort.order === 'ID'">
                <i class="fas fa-caret-up" v-show="driverSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!driverSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'sortable' + (isSorting ? ' disabled' : '')" @click="sort('firstName')">
              <span>{{ $t('dispatch.driverTable.name') }}</span>
              <span v-show="driverSort.order === 'firstName'">
                <i class="fas fa-caret-up" v-show="driverSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!driverSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'sortable' + (isSorting ? ' disabled' : '')" @click="sort('accountType')">
              <span>{{ $t('dispatch.driverTable.license') }}</span>
              <span v-show="driverSort.order === 'accountType'">
                <i class="fas fa-caret-up" v-show="driverSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!driverSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th>{{ $t('dispatch.driverTable.phone') }}</th>
            <!-- <th>{{ $t('dispatch.driverTable.services') }}</th> -->
            <th v-if="staging">STAGING LOT</th>
            <th>{{ $t('dispatch.driverTable.pax') }}</th>
            <th v-show="onDuty && !staging" v-bind:class="'sortable' + (isSorting ? ' disabled' : '')" @click="sort('status')">
              <span>{{ $t('dispatch.driverTable.status') }}</span>
              <span v-show="driverSort.order === 'status'">
                <i class="fas fa-caret-up" v-show="driverSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!driverSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:class="{ driver: true, new: driver.isNew }" v-for="(driver, index) in drivers" :key="index">
            <td>
              <input type="radio" name="seletedDriver" :value="driver.id" v-model="selectedDriver" />
            </td>
            <td class="map-button" v-show="onDuty">
              <a href="javascript:;" @click="showOnMap(driver)"
                 v-bind:class="{
                   disabled: loadingDriverId !== null,
                   selected: (driverIdsInMap.indexOf(driver.id) > -1)
                 }">
                <i v-show="loadingDriverId !== driver.id"
                  class="fas fa-map-marker-alt"></i>
                <i class="fas fa-spinner fa-spin fa-fw" v-show="loadingDriverId === driver.id"></i>
              </a>
            </td>
            <td class="id"><a :href="'/#/provider/' + driver.id" target="_blank">{{ driver.driverNum }}</a></td>
            <td><span :class="{'has-exp-doc':driver.hasExpiringDoc}">{{ driver.firstName }} {{ driver.lastName }}</span></td>
            <td>
              <span v-bind:class="'license-type ' + driver.licenseType">{{ driver.licenseType }}</span></td>
            <td>
              <a href="javascript:;" @click="callDriver(driver)">{{ driverPhoneDisplay(driver) }}</a>
            </td>
            <!-- <td>
              <div v-if="!staging">
                <span v-if="driver.serviceTypes.length <= 0">N/A</span>
                <span v-else-if="useOldQuatation" v-bind:class="'service-type ' + serviceType.class"
                      v-for="serviceType in driver.serviceTypes" style="margin: 0 3px 3px 0;">
                  {{ serviceType.label }}
                </span>
                <span class="service-type" v-if="false" :style="{background: serviceType.color}" v-else>{{ serviceType.label }}</span>
              </div>
              <div v-else>
                <div v-for="service in driver.stagingLot.services"
                     v-bind:class="'service-type ' + service.serviceClass">
                  <span>{{ service.serviceName }}<br/>{{ service.status }}<br/>Priority:{{ service.priority }}</span>
                </div>
              </div>
            </td> -->
            <td v-if="staging">
              {{ driver.stagingLot.name }}
            </td>
            <td>
              <span v-if="onDuty">{{ driver.onBoard }}/{{ driver.capacity }}</span>
              <span v-else>{{ driver.capacity }}</span>
            </td>
            <td v-show="onDuty && !staging">
              <span>{{ driver.status }}</span>
              <span v-if="driver.rsvp !== null">
                (<a :href="'/#/reservation/' + driver.rsvp.rsvpId" target="_blank">{{ driver.rsvp.rsvpId }}</a>)
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-bind:class="{ paging: true, disabled: isPageLoading }"
            v-show="totalPages > 1">
        <a v-bind:class="{
             'page page-btn back': true,
             disabled: currentPage === 1
          }" href="javascript:;" @click="pageBtn(false)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-left': !isLoadingBack,
            'fa-spinner fa-spin': isLoadingBack
          }"></i>
        </a>
        <select class="page page-number" v-model.number="currentPage" @change="loadPage">
          <option v-for="n in totalPages" :value="n">{{ n }}</option>
        </select>
        <a v-bind:class="{
             'page page-btn next': true,
             disabled: currentPage === totalPages
          }" href="javascript:;" @click="pageBtn(true)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-right': !isLoadingNext,
            'fa-spinner fa-spin': isLoadingNext
          }"></i>
        </a>
      </div>

    </div>
    <div v-else>
      <div class="no-drivers">
        <div v-if="isLoading">
          <ellipsis-loader></ellipsis-loader>
          <div class="title">{{ $t('dispatch.driverTable.loading.title') }}</div>
          <div class="content">{{ $t('dispatch.driverTable.loading.content') }}</div>
        </div>
        <div v-else>
          <div v-if="noDriversFound">
            <i class="far fa-frown fa-4x fa-fw"></i>
            <div class="title">Nothing here...</div>
            <div class="content">We can't find any drivers using the filters you provided.</div>
          </div>
          <div v-else>
            <div v-if="onDuty">
              <div v-if="staging">
                <img src="/assets/img/offline.png" />
                <div class="title">No one's in staging.</div>
                <div class="content">There's no driver in the staging area at the moment.</div>
              </div>
              <div v-else>
                <img src="/assets/img/offline.png" />
                <div class="title">{{ $t('dispatch.driverTable.empty.title') }}</div>
                <div class="content" v-html="$t('dispatch.driverTable.empty.content')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'

export default {
  name: 'driver-table',
  props: [ 'onDuty', 'staging' ],
  components: { EllipsisLoader },
  data () {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false
    }
  },
  computed: {
    drivers () {
      let self = this
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.drivers
        }
        return self.$store.state.dispatch.onDuty.drivers
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.drivers
    },
    isLoading () {
      let self = this
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.loading
        }
        return self.$store.state.dispatch.onDuty.loading
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.loading
    },
    noDriversFound () {
      let self = this
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.noDriversFound
        }
        return self.$store.state.dispatch.onDuty.noDriversFound
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.noDriversFound
    },
    driverIdsInMap () { return this.$store.state.dispatch.driverIdsInMap },
    loadingDriverId () { return this.$store.state.dispatch.loadingDriverId },
    selectedDriver: {
      get () { return this.$store.state.dispatch.selectedDriver },
      set (value) { this.$store.commit('dispatch/setSelectedDriver', value) }
    },
    totalPages () {
      let self = this
      if (self.onDuty) {
        if (self.staging) {
          return self.$store.state.dispatch.staging.totalPages
        }
        return self.$store.state.dispatch.onDuty.totalPages
      }
      // return off duty
      return self.$store.state.dispatch.offDuty.totalPages
    },
    currentPage: {
      get () {
        let self = this
        if (self.onDuty) {
          if (self.staging) {
            return self.$store.state.dispatch.staging.pageNum
          }
          return self.$store.state.dispatch.onDuty.pageNum
        }
        // return off duty
        return self.$store.state.dispatch.offDuty.pageNum
      },
      set (value) {
        let self = this
        if (self.onDuty) {
          if (self.staging) {
            self.$store.commit('dispatch/setStagingPageNumber', value)
            return
          }
          self.$store.commit('dispatch/setOnDutyPageNumber', value)
          return
        }
        self.$store.commit('dispatch/setOffDutyPageNumber', value)
      }
    },
    driverSort () {
      let self = this
      if (self.onDuty) {
        if (self.staging) {
          return {
            order: self.$store.state.dispatch.staging.order,
            asc: self.$store.state.dispatch.staging.asc
          }
        }
        return {
          order: self.$store.state.dispatch.onDuty.order,
          asc: self.$store.state.dispatch.onDuty.asc
        }
      }
      return {
        order: self.$store.state.dispatch.offDuty.order,
        asc: self.$store.state.dispatch.offDuty.asc
      }
    },
    useOldQuatation () { return CONFIG.useOldQuatation },
    driversTotal () {
      let totalItem = this.$store.state.dispatch.totalDrivers
      return this.onDuty ? totalItem.onDuty : totalItem.offDuty
    }
  },
  methods: {
    callDriver (driver) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    showOnMap (driver) {
      let self = this
      let driverIdsInMap = self.$store.state.dispatch.driverIdsInMap
      let driverIndex = driverIdsInMap.indexOf(driver.id)
      if (driverIndex >= 0) {
        self.$store.commit('dispatch/removeDriverInMap', driver)
        return
      }

      self.$store.commit('dispatch/setLoadingDriverId', driver.id)
      ApiDispatchDrivers.getLocation(self, driver.id, r => {
        self.$store.commit('dispatch/setLoadingDriverId', null)
        if (r.error) {
          // TODO process error
          return
        }

        if (r.list.length <= 0) {
          // TODO we cant find the driver
          return
        }

        let coords = {
          lat: r.list[0].lat,
          lng: r.list[0].lng
        }
        driver.coords = coords
        self.$store.commit('dispatch/addDriverInMap', driver)
      })


      setTimeout( () => {

      }, 1500)
    },
    pageBtn (isNext) {
      let self = this
      let pageChange = isNext ? 1 : -1
      if (isNext) {
        self.isLoadingNext = true
      } else {
        self.isLoadingBack = true
      }
      if (self.onDuty) {
        if (self.staging) {
          self.$store.commit('dispatch/setStagingPageNumber',
            self.$store.state.dispatch.staging.pageNum + pageChange)
        } else {
          self.$store.commit('dispatch/setOnDutyPageNumber',
            self.$store.state.dispatch.onDuty.pageNum + pageChange)
        }
      } else {
        self.$store.commit('dispatch/setOffDutyPageNumber',
          self.$store.state.dispatch.offDuty.pageNum + pageChange)
      }
      self.loadPage()
    },
    loadPage () {
      let self = this
      self.isPageLoading = true
      if (!self.useOldQuatation) {
        let data = {
          onDuty: self.onDuty,
          isStaging: self.staging
        }
        ApiDispatchDrivers.getDriverListV2(self, data, r => {
          self.isPageLoading = false
          self.isLoadingBack = false
          self.isLoadingNext = false

          if (r.error) { return }
          self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))
        })
      } else {
        ApiDispatchDrivers.getDriverList(self, self.onDuty, self.staging, r => {
          self.isPageLoading = false
          self.isLoadingBack = false
          self.isLoadingNext = false

          if (r.error) {
            return
          }

          self.$plugins.smoothScroll.scrollTo(document.getElementById('driver-list-container'))
        })
      }
    },
    sort (order) {
      let self = this
      let existingOrder = self.driverSort.order
      let existingAsc = self.driverSort.asc

      let asc = true
      if (order === existingOrder) {
        asc = !existingAsc
      }

      let sortMutation = 'dispatch/setOnDutySorting'
      if (!self.onDuty) {
        sortMutation = 'dispatch/setOffDutySorting'
      }
      if (self.staging) {
        sortMutation = 'dispatch/setStagingSorting'
      }

      self.$store.commit(sortMutation, {
        order: order,
        asc: asc
      })

      self.isSorting = true

      if (!self.useOldQuatation) {
        let data = {
          onDuty: self.onDuty,
          isStaging: self.staging
        }
        ApiDispatchDrivers.getDriverListV2(self, data, r => {
          self.isSorting = false
        })
      } else {
        ApiDispatchDrivers.getDriverList(self, self.onDuty, self.staging, r => {
          self.isSorting = false
        })
      }
    },
    driverPhoneDisplay (data) {
      if (!data.countryCode) return data.phone
      return `+${data.countryCode} ${data.nationalNumber || data.phone}`
    }
  },
  mounted () {
    this.loadPage()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_service-types';

.total{
  font-size: 12px;
  font-weight: 700;
  color: #777;
  position: relative;
  text-align: right;
  margin-bottom: 5px;
}
table{
  border-collapse: collapse;
  width: 100%;
}

.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{
    padding: 5px 10px;
    &.sortable {
      cursor: pointer;
      text-decoration: underline;
      color: #333;
      transition: all 250ms;

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }
}

.driver{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  &.new {
    border-left: 5px solid #F25E0D;
  }

  & td{
    padding: 10px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    &.map-button{
      padding: 10px 0;

      & a{
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        display: inline-block;
        border-radius: 30px;
        transition: all 250ms;

        & i {line-height: inherit;}

        &.disabled{
          pointer-events: none;
          opacity: 0.5;
          background-color: #bbb;
        }
        &.selected{
          background-color: #26D97A;
        }
      }
    }

    & input{
      margin-top: 0;
      width: 13px;
    }
  }

  & a{ font-weight: 700; }
}

.no-drivers{
  position: absolute;
  top: calc(50% - 111px);
  left: 10%;
  width: 80%;
  text-align: center;

  & img{
    display: block;
    width: 100px;
    margin: 0 auto;
  }

  & .fa-frown { color: #3F2975; }
  & .title {
    font-weight: 700;
    margin-top: 10px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

.paging {
  margin: 15px auto 0;
  width: 103px;
  opacity: 1;
  transition: all 250ms;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  & .page{
    display: inline-block;
    vertical-align: middle;
    width: auto;

    &:not(:first-child) {
      margin-left: -5px;
    }
  }

  & .page-btn {
    background-color: #f5f5f5;
    border: 1px solid rgba(0,0,0,0.25);
    color: #777;
    padding: 5px 5px;
    font-size: 12px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    & i { line-height: inherit; }

    &.back {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &.next {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  & .page-number {
    border-radius: 0;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.3);
    line-height: inherit;
    font-size: 12px;
    margin: 0;
    width: 50px;
    font-weight: 700;
    padding: 5px 10px;
    color: #333;
    text-align: center;
    appearance: none;
    outline: 0;
    text-align-last:center;
  }
}

.has-exp-doc{
  color: #f00;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DriverTable.vue